import React from "react";

import * as styles from "./styles";

export const Root = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => <div className={`${styles.wrapper} ${className || ""}`}>{children}</div>;

// Export children
export { Item } from "./Item";
